export default __webpack_public_path__ + "static/media/logoLine.42c309f5.webp";